import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Search } from "lucide-react";
import { Row } from "@/components/ops/DayMonitor";

const FILTERS = [["", "Todos"], ["none", "Sem cobrança"], ["failed", "Falhou"], ["ok", "Receberam"]];
const st = (c) => {
  const s = [c.sms_st.status, c.wa_st.status];
  if (s.some((x) => x === "sent" || x === "delivered")) return "ok";
  return s.includes("failed") ? "failed" : "none";
};

export const RecoverDialog = ({ group, label, onClose }) => {
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  const [f, setF] = useState("");
  const load = useCallback(() => api.get("/recover/list", { params: { group } }).then((r) => setD(r.data)), [group]);
  useEffect(() => { load(); }, [load]);
  const term = q.trim().toLowerCase();
  const list = (d?.clients || []).filter((c) => (!f || st(c) === f)
    && (!term || [c.name, c.panel_user, c.whatsapp, c.account].some((v) => (v || "").toLowerCase().includes(term))));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="recover-dialog" className="max-w-3xl border-[#1F293D] bg-[#0F141F] text-slate-200">
        <DialogHeader>
          <DialogTitle className="text-white">{label}{d ? ` · ${d.total.toLocaleString("pt-BR")} clientes` : ""}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap items-center gap-2">
          <div className="relative min-w-[220px] flex-1">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <input data-testid="recover-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar nome, usuário, WhatsApp..."
              className="w-full rounded-lg border border-[#1F293D] bg-[#0B0F17] py-2 pl-9 pr-3 text-sm text-white" />
          </div>
          {FILTERS.map(([k, l]) => (
            <button key={k || "all"} data-testid={`recover-filter-${k || "all"}`} onClick={() => setF(k)}
              className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${f === k ? "bg-sky-500 text-slate-950" : "border border-[#1F293D] text-slate-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
        <div data-testid="recover-list" className="max-h-[60vh] space-y-0.5 overflow-y-auto pr-1">
          {!d && <div className="py-10 text-center text-sm text-slate-500">Carregando...</div>}
          {list.map((c) => <Row key={c.id} c={c} ruleId={null} onSent={load} />)}
          {d && !list.length && <div data-testid="recover-empty" className="py-10 text-center text-sm text-slate-500">Nenhum cliente neste filtro.</div>}
          {d && d.clients.length < d.total && <div className="py-2 text-center text-[11px] text-slate-500">Mostrando os {d.clients.length} vencidos mais recentes.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
